/**
 * Author : Komal Sadrani
 * Changes : Aaditya Gandhare
 * Modified : 13th Aug, 2018
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '../../components/login/login.component';
import { ConsignmentsComponent } from '../../components/consignments/consignments.component';
import { ConsignmentDetailComponent } from '../../components/consignment-detail/consignment-detail.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'consignments-list/:referrer/:file_name', component: ConsignmentsComponent },
  { path: 'consignments-list', component: ConsignmentsComponent },
  { path: 'consignment-detail/:id', component: ConsignmentDetailComponent },
  { path: 'login/:referrer/:file_name', component: LoginComponent },
  { path: '**', component: LoginComponent }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
  ],
  exports: [ RouterModule ],
  declarations: []
})
export class AppRoutingModule { }
